module.exports = __webpack_public_path__ + "img/icon--youtube.cbfd6873.svg";